<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <br />
        <br />
        <br />
        <br />
        <br />

        <section>
          <ValidationObserver ref="form">
            <span class="label">
              휴대폰번호
              <span class="required"><span class="blind">필수</span></span>
            </span>

            <ValidationProvider name="휴대폰번호" rules="required|cellNum" v-slot="{ errors }" vid="cellNum" ref="cellNum">
              <div class="setPhone">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="cellNum"
                  v-onlyNum
                />
                <button type="button" class="btn_s round s" @click="sendAuthNumber">
                  {{ authButtonTitle }}
                </button>
              </div>
              <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
            <div>
              <ValidationProvider name="인증번호" rules="required" v-slot="{ errors }" vid="authKey">
                <input type="number" id="phone_3" class="ipt addTxt" title="인증번호 입력" placeholder="" value="" v-model="authKey" v-onlyNum />
                <span class="txt">
                  유효시간
                  <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                </span>
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </ValidationObserver>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="test">인증번호 체크</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty } from '@/common/common.function'; // TODO 공통함수 선언 및 효율적으로 사용방법 확인 필요
import { INPUT_INFO_CHECK, AUTH_TIMEOUT } from '@/store/message.type'; // 공통 필수 MSG
// import { SET_JOIN_INFO } from '@/store/message.type'; // 각 페이지에서 필요한 MSG

export default {
  name: 'SendAuthNumber',
  components: {
    MessagePop,
  },
  data() {
    return {
      headerTitle: '인증번호공통', // 헤더 타이틀

      cellNum: null, // 핸드폰번호
      authKey: null, // 인증번호 입력란
      // authTime: 180, // 인증시간(초)
      authTime: 10, // 초기 세팅 시간 테스트로 10초로 설정 원래는 180초
      authButtonTitle: '인증번호요청', // 인증번호 버튼명 ( 인증번호요청 / 재요청 )

      messagePop: false, // 메세지 팝업 open close
    };
  },
  watch: {
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        this.authTime = 10; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
  },
  methods: {
    // 인증번호 요청 버튼 클릭시
    sendAuthNumber() {
      // 핸드폰번호가 정확한지 확인하기 위해 로직 넣음...
      this.$refs.cellNum.validate().then(success => {
        // userId 등 필수 값 검증
        // if (!success.valid || this.userId == null) {
        if (!success.valid) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          ApiService.service('POST', 'common/sms/auth', {
            request: {
              cellNum: this.cellNum,
              /*
              SENDTYPE:
              SPSM0001 : 가입시 인증번호 SMS 발송,
              SPSM0002 : 아이디 분실 시 SMS 발송,
              SPSM0003 : 비밀번호 분실,
              SPSM0004 : 전자계약서 다운로드 시 SMS 발송,
              SPSM0005 : 비회원 주문신청,
              SPSM0006 : 회원 주문신청,
              */
              sendType: 'SPSM0001',
              userId: 'rayn25',
              // userId: this.userId,
            },
            serviceType: 'web/app',
          })
            .then(({ data }) => {
              this.authKey = data.result.authKey; // TODO 테스트로 임시로 인증번호 자동입력 처리 => 실제 문자발송시 자동입력 확인 필요
              this.tranId = data.result.transactionId;
              this.authButtonTitle = '재요청'; // 인증 진행시 버튼 TITLE 변경
              clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
              this.countDown = setInterval(() => {
                this.authTime--;
              }, 1000);
            })
            .catch(({ response }) => {
              console.log(response);
            });
        }
      });
    },
    test() {
      // 함수명은 각 페이지에 맞게 사용
      // 전체 폼 검증 수행
      this.$refs.form.validate().then(success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          // 인증번호 검증 및 validation 체크
          ApiService.service('POST', 'common/sms/auth/check', {
            request: {
              authKey: this.authKey,
              // birth: this.birth.substring(2),
              birth: '920223',
              cellNum: this.cellNum,
              smsType: 'SPSM0001',
              tranId: this.tranId,
              // userId: this.userId,
              userId: 'rayn25',
              // userName: this.userName,
              userName: '김형우',
            },
            serviceType: 'web/app',
          })
            .then(({ data }) => {
              console.log(data);
              // 인증번호 일치 하지 않을경우 => 기존가입자 체크 => 사용중인 아이디 체크
              if (!isEmpty(data.error)) {
                this.msg = data.error; // API에서 response 해주는 message
                this.errorCode = data.errorCode; // API에서 response 해주는 errorCode
                this.messagePop = true;
              } else {
                // 페이지별 로직 처리
                // 가입 정보 Object 생성후 vuex로 저장

                alert('인증성공하였습니다.');
                /*
                this.joinInfo = {
                  userId: this.userId,
                  password: this.password,
                  userName: this.userName,
                  birth: this.birth,
                  cellNum: this.cellNum,
                };
                this.$store.commit(SET_JOIN_INFO, this.joinInfo);
                this.$router.push('joinStep4');
                */
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
      });
    },
    close() {
      // 에러코드(this.errorCode) 에 따라 분기 필요할 수 있음
      this.messagePop = false;
    },
  },
};
</script>
